import React, { useEffect, useState } from "react";
import moment from "moment";
import DatePicker from "react-datepicker";
import { Calendar } from "primereact/calendar";
export interface CustomProps {
    task: any;
    isEdit?: boolean;
    onSetReminder: any;
    setTask: any;
    errors: any;
    handleValidation: any
}
const TaskRepetition: React.FC<CustomProps> = ({ task, onSetReminder, setTask, isEdit, errors, handleValidation }) => {
    const [weeklyDays, setWeeklyDays] = useState<any>([]);
    const [selectedDates, setSelectedDates] = useState<any>([]);
    const [selectedDays, setSelectedDays] = useState<any>([]);

    useEffect(() => {
        if (isEdit) {
            setWeeklyDays(task.repeat?.type === "weekly" ? task.repeat?.data || [] : []);
            setSelectedDays(task.repeat?.type === "monthly" ? task.repeat?.data || [] : []);
            setSelectedDates(task.repeat?.type === "yearly" ? task.repeat?.data || [] : []);
        }
    }, [isEdit, task]);

    const handleDayOfMonthChange = (e: any) => {
        const { value } = e.target;
        setSelectedDays((prev: any) =>
            prev.includes(value) ? prev.filter((d: any) => d !== value) : [...prev, value]
        );
    };

    const handleWeeklyDaysChange = (day: string) => {
        setWeeklyDays((prev: any) =>
            prev.includes(day) ? prev.filter((d: any) => d !== day) : [...prev, day]
        );
    };

    const handleYearlyDateChange = (e: any) => {
        const { value } = e.target;
        setSelectedDates((prev: any) =>
            prev.some((d: any) => d === moment(value).format("DD MMM"))
                ? prev.filter((d: any) => d !== moment(value).format("DD MMM"))
                : [...prev, moment(value).format("DD MMM")]
        );
    };

    useEffect(() => {
        setTask((prev: any) => ({ ...prev, repeat: { ...prev.repeat, data: weeklyDays } }));
    }, [weeklyDays, setTask]);

    useEffect(() => {
        setTask((prev: any) => ({ ...prev, repeat: { ...prev.repeat, data: selectedDates } }));
    }, [selectedDates, setTask]);

    useEffect(() => {
        setTask((prev: any) => ({ ...prev, repeat: { ...prev.repeat, data: selectedDays } }));
    }, [selectedDays, setTask]);

    const handleDateChange = (event: any) => {
        if (!event.value) return;

        const formattedDates = Array.isArray(event.value)
            ? event.value.map((date: any) => moment(date).format("DD MMM YYYY"))
            : [moment(event.value).format("DD MMM YYYY")];

        setSelectedDates(formattedDates);
    };

    return (
        <div className="mb-3">
            <hr />
            <div className="row">
                <div className="col-md-6">
                    <label className="form-label">Repetition</label>
                    <div className="mb-3">
                        <input
                            type="checkbox"
                            name="isRepeated"
                            id="isRepeated"
                            checked={task.isRepeated}
                            onChange={onSetReminder}
                        />{" "}
                        Is task repeated?
                    </div>
                </div>

                {task.isRepeated && (
                    <div className="col-md-6">
                        <label className="form-label">End Date <span className="text-danger">*</span></label>
                        <DatePicker id="endDate"
                            name="endDate"
                            className="form-control"
                            value={task.endDate ? moment(task.endDate).format('YYYY-MM-DD') : ''}
                            minDate={new Date()}
                            onChange={(event: any) => setTask((prev: any) => ({
                                ...prev,
                                endDate: moment.tz(event, 'Asia/Kolkata'),
                            }))}
                        />
                        {task.endDate && task.endDate != "" && <div className="valid-feedback" style={{ display: 'block' }}>Looks good!</div>}
                        {errors.endDate && <div className="invalid-feedback" style={{ display: 'block' }}>This field is required.</div>}
                    </div>
                )}
            </div>

            {task.isRepeated && (
                <div className="row">
                    <div className="col-md-6">
                        <label className="form-label">Repetition Frequency</label>
                        <div className="d-flex gap-2" id="repeat">
                            {["hourly", "daily", "weekly", "monthly", "yearly", "custom"].map((typeKey) => (
                                <button
                                    type="button"
                                    key={typeKey}
                                    className={`btn btn-sm btn-${task.repeat?.type === typeKey ? "primary" : "outline-primary"}`}
                                    onClick={() => {
                                        setTask((prev: any) => ({ ...prev, repeat: { ...prev.repeat, type: typeKey } }));
                                        setSelectedDates([]);
                                        setSelectedDays([]);
                                        setWeeklyDays([]);
                                    }}
                                >
                                    {typeKey.charAt(0).toUpperCase() + typeKey.slice(1)}
                                </button>
                            ))}
                        </div>
                        {task.repeat?.type && task.repeat?.type != "" && <div className="valid-feedback" style={{ display: 'block' }}>Looks good!</div>}
                        {errors.repeattype && <div className="invalid-feedback" style={{ display: 'block' }}>This field is required.</div>}
                    </div>
                    {task.repeat?.type && (
                        <div className="col-md-6">
                            <label className="form-label">Repetition Summary</label>
                            <p style={{ color: "green", fontStyle: "italic" }}>
                                {task.repeat?.type === "hourly" && <>Task will repeat <strong>every hour</strong>.</>}
                                {task.repeat?.type === "daily" && <>Task will repeat <strong>daily</strong>.</>}
                                {task.repeat?.type === "weekly" && (
                                    <p>Task will repeat on:{" "}
                                        <strong>{weeklyDays.length > 0 ? weeklyDays.join(", ") : "No days selected."}</strong>
                                    </p>
                                )}
                                {task.repeat?.type === "monthly" && (
                                    <p>Task will repeat on:{" "}
                                        <strong>{selectedDays.length > 0 ? selectedDays.join(", ") : "No days selected."}</strong>
                                    </p>
                                )}
                                {task.repeat?.type === "yearly" && (
                                    <p>Task will repeat on:{" "}
                                        <strong>{selectedDates.length > 0 ? selectedDates.join(", ") : "No days selected."}</strong>
                                    </p>
                                )}
                                {["custom"].includes(task.repeat?.type) && (
                                    <p>Task will repeat on:{" "}
                                        <strong>{selectedDates.length > 0 ? selectedDates.join(", ") : "No days selected."}</strong>
                                    </p>
                                )}
                            </p>
                        </div>
                    )}

                    {task.repeat?.type === "weekly" && (
                        <div className="col-md-6">
                            <label className="form-label">Select Days of the Week:</label>
                            <div className="d-flex flex-wrap">
                                {["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map((day) => (
                                    <label key={day} className="me-3" htmlFor={`day-${day}`}>
                                        <input
                                            id={`day-${day}`}
                                            type="checkbox"
                                            checked={weeklyDays.includes(day)}
                                            onChange={() => handleWeeklyDaysChange(day)}
                                        />
                                        <span style={weeklyDays.includes(day) ? { color: "green", fontStyle: "italic", fontWeight: 600 } : {}}>
                                            {day}
                                        </span>
                                    </label>
                                ))}
                            </div>
                            {task.repeat?.data?.length > 0 && <div className="valid-feedback" style={{ display: 'block' }}>Looks good!</div>}
                            {errors.repeatdata && <div className="invalid-feedback" style={{ display: 'block' }}>This field is required.</div>}
                        </div>
                    )}

                    {task.repeat?.type === "monthly" && (
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Select Days of the Month:</label>
                            <select
                                id="dayOfMonth"
                                onChange={handleDayOfMonthChange}
                                className="form-select"
                            >
                                {Array.from({ length: 31 }, (_, i) => (
                                    <option key={i} value={i + 1}>
                                        {i + 1}
                                    </option>
                                ))}
                            </select>
                            {task.repeat?.data && <div className="valid-feedback" style={{ display: 'block' }}>Looks good!</div>}
                            {errors.repeatdata && <div className="invalid-feedback" style={{ display: 'block' }}>This field is required.</div>}
                        </div>
                    )}

                    {task.repeat?.type === "yearly" && (
                        <div className="col-md-6 mb-3">
                            <label className="form-label">Select Date of the Year:</label>
                            <input type="date" onChange={handleYearlyDateChange} className="form-control" />
                            {task.repeat?.data && task.repeat?.data.length > 0 && <div className="valid-feedback" style={{ display: 'block' }}>Looks good!</div>}
                            {errors.repeatdata && <div className="invalid-feedback" style={{ display: 'block' }}>This field is required.</div>}

                        </div>
                    )}

                    {task.repeat?.type === "custom" && (
                        <div className="col-md-6 mb-3">
                            <label className="form-label"> Select Custom Dates:</label>
                            <Calendar
                                className="datepickers mb-4"
                                value={selectedDates.map((d: any) => new Date(d))}
                                onChange={handleDateChange}
                                inline
                                selectionMode="multiple"
                            />
                            {task.repeat?.data && <div className="valid-feedback" style={{ display: 'block' }}>Looks good!</div>}
                            {errors.repeatdata && <div className="invalid-feedback" style={{ display: 'block' }}>This field is required.</div>}
                        </div>
                    )}
                </div>
            )
            }
            <hr />
            <div className="row ">
                <div className="col-md-6">
                    <label className="form-label">Reminder</label>
                    <div className="mb-3">
                        <input
                            type="checkbox"
                            name="isReminder"
                            id="isReminder"
                            checked={task.isReminder}
                            onChange={onSetReminder}
                        />{" "}
                        Set a reminder?
                    </div>
                </div>

                {task.isReminder && (<>
                    <div className="col-md-6">
                        <label className="form-label">Reminder Frequency</label>
                        <div className="d-flex justify-content-between mt-1" id="reminder">
                            {["minutes", "hours", "days", "weeks", "months", "years"].map((type) => (
                                <button
                                    key={type}
                                    type="button"
                                    className={`btn btn-sm ${task.reminder?.type === type ? "btn-primary" : "btn-outline-primary"}`}
                                    onClick={() => setTask((prev: any) => ({ ...prev, reminder: { ...prev.reminder, type } }))}
                                >
                                    {type.charAt(0).toUpperCase() + type.slice(1)}
                                </button>
                            ))}
                        </div>
                        {task.reminder?.type && task.reminder?.type != "" && <div className="valid-feedback" style={{ display: 'block' }}>Looks good!</div>}
                        {errors.remindertype && <div className="invalid-feedback" style={{ display: 'block' }}>This field is required.</div>}
                    </div>
                    <div className="form-group col-md-6">
                        <label className="form-label" htmlFor="reminderTime">Reminder Time (Enter number of units)</label>
                        <input
                            type="number"
                            className="form-control"
                            id="value"
                            name="value"
                            placeholder="Enter reminder time (e.g., '10')"
                            value={task.reminder.value ?? ""}
                            min={0}
                            onChange={(e) => {
                                const numValue = e.target.value === "" ? "" : Number(e.target.value);
                                setTask((prev: any) => ({
                                    ...prev,
                                    reminder: {
                                        ...prev.reminder,
                                        value: numValue,
                                        data: e.target.value === "" ? [] : [e.target.value],
                                    },
                                }));
                            }}
                        />
                        {task.reminder?.value !== "" && task.reminder?.value !== null && task.reminder?.value !== undefined && (
                            <div className="valid-feedback" style={{ display: 'block' }}>Looks good!</div>
                        )}
                        {errors.remindervalue && <div className="invalid-feedback" style={{ display: 'block' }}>This field is required.</div>}
                    </div></>
                )}
            </div>
        </div >
    );
};

export default TaskRepetition;
